import "./LoadingSpinner.scss";

function LoadingSpinner() {
  return <div className="spinner"></div>;
}

export default LoadingSpinner;
